import { render, staticRenderFns } from "./PromotionLayout.vue?vue&type=template&id=04536f88&scoped=true&"
import script from "./PromotionLayout.vue?vue&type=script&lang=js&"
export * from "./PromotionLayout.vue?vue&type=script&lang=js&"
import style0 from "./PromotionLayout.vue?vue&type=style&index=0&id=04536f88&lang=less&scoped=true&"
import style1 from "./PromotionLayout.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04536f88",
  null
  
)

export default component.exports